import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { LetterDirectionality } from '../../api/WritingDesk';
import { serverUrl } from '../../config';
import { useAuthenticateApiCall } from '../hooks/useAuthenticateApiCall';

export type SentLetter = {
  id: string;
  title: string;
  body: string;
  correspondent_name: string;
  directionality: LetterDirectionality;
  read?: boolean;
  sender: string;
};

const fetchLetter = (token: string) => (letterId: string) => async (): Promise<SentLetter> =>
  await fetch(`${serverUrl}/api/letters/received/${letterId}/`, {
    method: 'get',
    headers: { authorization: `Token ${token}` },
  }).then((r) => r.json());

const readLetter = (token: string) => async (letterId: string) => {
  await fetch(`${serverUrl}/api/letters/received/${letterId}/read`, {
    method: 'post',
    headers: { authorization: `Token ${token}` },
  }).then((r) => r.json());
};

const useMarkAsRead = (data: SentLetter | undefined) => {
  const authedMarkAsRead = useAuthenticateApiCall(readLetter);

  useEffect(() => {
    data && data.read === false && authedMarkAsRead(data.id);
  }, [data, authedMarkAsRead]);
};

export const useLoadLetter = (id: string) => {
  const fetcher = useAuthenticateApiCall(fetchLetter);
  const { data, isLoading } = useQuery(['letter', id], fetcher(id));

  useMarkAsRead(data);

  return { data, isLoading };
};
